import { type ReactNode } from "react";
import { LazyMotion, domAnimation, MotionConfig } from "framer-motion";

export const MotionProvider = ({ children }: { children: ReactNode }) => (
  <LazyMotion features={domAnimation} strict>
    <MotionConfig reducedMotion="user">{children}</MotionConfig>
  </LazyMotion>
);
